<template>
    <div class="employerDetailsClient">

        <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
              <div class="col-md-5">
                <p class="u-back"><a href="javascript: void(0)" @click="backToEmployerList()"><i class="fa fa-chevron-left"></i> Back</a></p>
              </div>
              <div class="col-md-7 text-right">
                <ul class="o-filter-area">
                  <li><a href="javascript: void(0)" @click="gotoEditEmployer()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</a></li>
                </ul>
              </div>
              <div class="col-md-8 c-user">{{detailEmployer && detailEmployer.image}}
                <div class="c-user__profile-pic u-mar-right-10">
                    <img v-if="detailEmployer && detailEmployer.image!='' && detailEmployer.image!=null" :src="detailEmployer.image" />
                    <img v-else src="static/assets/images/user1.png" />
                </div>
                <div class="c-user__profile-details">
                  <h4 class="h1">{{detailEmployer?detailEmployer.name:''}}</h4>
                  <p>Email ID: {{detailEmployer?detailEmployer.email:''}}</p>
                </div>
              </div>
              <div class="col-md-4 text-right">
                 <div class="contact-info-style">
                  <h4 class="h1">Billed Users : {{detailEmployer?detailEmployer.employer_users.length-1:''}}</h4>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- /Heading Section -->
            <!-- Main Body Content area -->

            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Contact Persons:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Contact Person Name</h5>
                          </div>
                          <div class="col-sm-3">
                            <h5>Email</h5>
                          </div>
                          <div class="col-sm-3">
                            <h5>Phone</h5>
                          </div>
                          <div class="col-sm-3">
                            <h5>Client Access</h5>
                          </div>
                        </div>
                        <div v-for="employer in (detailEmployer?detailEmployer.employer_users:[])" class="row contact-list-style">
                          <div class="col-sm-3">
                            <!-- <h5>Contact Person Name</h5> -->
                            <p>
                              {{employer.user.first_name}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <!-- <h5>Email</h5> -->
                            <p>
                              {{employer.user.email}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <!-- <h5>Phone</h5> -->
                            <p v-for="phone in employer.user.phones" v-if ="phone.label=='Primary phone'">
                              {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <!-- <h5>Client Access</h5> -->
                            <p>
                              <span v-for="client in associateClientList" v-if="client.status_id!=null">{{client.client.subdomain}}</span>
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Phone & Fax:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Primary Phone No.</h5>
                            <div v-if="detailEmployer">
                              <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Primary phone'">
                                {{phone.phone_number}}
                              </p>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <h5>Secondary Phone No.</h5>
                            <div v-if="detailEmployer">
                              <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Secondary phone'">
                                  {{phone.phone_number}}
                              </p>
                            </div >
                          </div>
                          <div class="col-sm-3">
                            <h5>Cell Phone</h5>
                            <div v-if="detailEmployer">
                              <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Cell phone'">
                                  {{phone.phone_number}}
                              </p>
                            </div >
                          </div>
                          <div class="col-sm-3">
                            <h5>Fax</h5>
                            <div v-if="detailEmployer">
                              <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Fax'">
                                  {{phone.phone_number}}
                              </p>
                            </div >
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Address:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Street</h5>
                            <p v-if="detailEmployer && detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].address}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>City</h5>
                            <p v-if="detailEmployer && detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].municipality}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>State</h5>
                            <p v-if="detailEmployer && detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].state_province}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Zip</h5>
                            <p v-if="detailEmployer && detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].postcode}}
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- /Main Body Content area -->
    </div>
</template>
<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../../services.js';
    import {
        global
    } from '../../../global.js';

    export default {
        data() {
            return {
                detailEmployer:null,
                associateClientList:null,
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
            })
        },
        methods: {
            getDate(str) {
                return dateTimeConvert.localDate(str);
                //var date = str.split(" ");
                //return date[0];
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            empDetails() {
                this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                service.get('employer/' + atob(this.$route.params.id), {
                    'Authorization': this.userToken,
                }).
                then((res) => {
                    this.$Progress.finish();
                    this.detailEmployer = res.data.result;

                }).catch((err) => {
                    console.log(err);
                });
            },
            getEmployerClient(){
              service.get('employer/'+atob(this.$route.params.id)+'/getEmployerClientAssociation', {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
              })
              .then((res) => {
                  this.associateClientList = res.data.result;
                  console.log(this.associateClientList);
              }).catch((err) => {
                  console.log(err);
              });
            },
            backToEmployerList() {
                this.$router.push({
                    path: `/clientEmployersList`
                });
            },
            gotoEditEmployer() {
                this.$router.push({
                    path: `/editEmployerClient/`+this.$route.params.id
                });
            },
            phoneNumberCheck(phone_number, type) {
                let self = this;
                let primaryPhone = "";
                if (phone_number) {
                    phone_number.forEach(function(employerphone) {
                        if (employerphone.label == type) {
                            //console.log(employerphone.label);
                            primaryPhone = employerphone.phone_number;
                        }
                    });
                }
                return primaryPhone;

            },

        },
        created() {
            this.empDetails();
            this.getEmployerClient();

        }
    }

</script>
<style scoped>
.contact-list-style{
  padding-top: 15px;
}
.contact-info-style{
  padding-top: 50px;
    
}
</style>